import React, { useState, useEffect } from "react";
import useStorageState from "@/hooks/useStorageState";
import { createModel } from "hox";
import { ITurnoverSearch, ITurnoverDetail, ITurnoverStatistics } from "./turnoverTypes"
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, mianCode } from "@/utils/constants";
import { IPgProps, ISearchPage } from "@/types/SCMTypes";
import { turnoverService } from "./turnoverService";
import { transPgToPagination, formatNum } from "@/utils/utils";
import { convertRes2Blob } from "@/utils/exportFile";
export const useTurnoverModel = createModel(function () {
    //列表数据源
    const [dataSource, setDataSource] = useState<ITurnoverDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<ITurnoverSearch>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initDesc: ITurnoverStatistics = {
        receivableAmount: 0,
        receivedAmount: 0,
    }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [descTotal, setDescTotal] = useState<ITurnoverStatistics>(initDesc);
    //选中的数据统计展示的数据
    const [rowsDescTotal, setRowsDescTotal] = useState<ITurnoverStatistics>(initDesc);
    const [descRows, setDescRows] = useState<ITurnoverDetail[]>([]);
    useEffect(() => {
        let newRowsDescTotal = initDesc
        descRows.forEach((item) => {
            let { receivableAmount, receivedAmount } = item
            newRowsDescTotal.receivableAmount += +formatNum(receivableAmount)
            newRowsDescTotal.receivedAmount += +formatNum(receivedAmount)
        })
        setRowsDescTotal(newRowsDescTotal)
    }, [descRows])
    const loadData = async (page?: ISearchPage, searchValue: ITurnoverSearch = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await turnoverService.turnover(searchParams);
        const { records, statistics, ...pg } = retData;
        setPgCfg(transPgToPagination({ ...pg, pageNum: pg.current }));
        setDataSource(records);
        setDescTotal(statistics);
    }
    //设置搜索value
    const updateSearchParam = (updateParam: ITurnoverSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    //列表导出
    const turnoverExcel = async () => {
        let result = await turnoverService.turnoverExcel({
            ...searchParam,
            id: selectedRowKeys.join(),
            pageSize: 0,
            pageNum: 0,

        });
        convertRes2Blob(result)
    }
    return {
        dataSource,
        searchParam,
        initPgCfg,
        pgCfg,
        selectedRowKeys,
        setDataSource,
        setSearchParam,
        setPgCfg,
        loadData,
        updateSearchParam,
        resetSearchParam,
        setSelectedRowKeys,
        descTotal, setDescTotal,
        rowsDescTotal, setRowsDescTotal,
        descRows, setDescRows,
        turnoverExcel

    }
})